<div class="filter-bar">
    @if (viewport.isMobile()) {
        <div class="filter-bar-header">
            <button
                type="button"
                class="filter-toggle"
                (click)="toggleExpanded()"
                [attr.aria-expanded]="isExpanded()">
                <i [class]="isExpanded() ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
                <span>Filters</span>
            </button>

            <div class="filter-actions">
                <p-button
                    icon="pi pi-filter-slash"
                    severity="secondary"
                    size="small"
                    [outlined]="true"
                    (onClick)="clearFilters()"
                    pTooltip="Clear all filters"
                    tooltipPosition="bottom"></p-button>
                <p-button
                    icon="pi pi-refresh"
                    size="small"
                    [loading]="isSyncing()"
                    (onClick)="refresh()"
                    pTooltip="Refresh NS statuses"
                    tooltipPosition="bottom"></p-button>
                <p-button
                    icon="pi pi-download"
                    severity="secondary"
                    size="small"
                    [outlined]="true"
                    (onClick)="requestDownload()"
                    pTooltip="Download quote log"
                    tooltipPosition="bottom"></p-button>
            </div>
        </div>
    }

    @if (isExpanded()) {
        <div class="filter-bar-body">
            <p-iconfield>
                <p-inputicon styleClass="pi pi-search" />
                <input
                    pInputText
                    type="text"
                    pSize="small"
                    [fluid]="true"
                    placeholder="Search"
                    [(ngModel)]="searchValue"
                    (ngModelChange)="applyFilters()" />
            </p-iconfield>

            <p-datepicker
                [(ngModel)]="startDateValue"
                (ngModelChange)="applyFilters()"
                placeholder="Received After"
                size="small"
                [fluid]="true"
                [showIcon]="true"
                [showClear]="true"></p-datepicker>

            <p-datepicker
                [(ngModel)]="endDateValue"
                (ngModelChange)="applyFilters()"
                placeholder="Received Before"
                size="small"
                [fluid]="true"
                [showIcon]="true"
                [showClear]="true"></p-datepicker>

            <p-datepicker
                [(ngModel)]="dueStartDateValue"
                (ngModelChange)="applyFilters()"
                placeholder="Due After"
                size="small"
                [fluid]="true"
                [showIcon]="true"
                [showClear]="true"></p-datepicker>

            <p-datepicker
                [(ngModel)]="dueEndDateValue"
                (ngModelChange)="applyFilters()"
                placeholder="Due Before"
                size="small"
                [fluid]="true"
                [showIcon]="true"
                [showClear]="true"></p-datepicker>

            <p-select
                [options]="nsCustomerOptions()"
                [(ngModel)]="nsCustomerValue"
                (ngModelChange)="applyFilters()"
                placeholder="Customer"
                optionLabel="label"
                optionValue="value"
                size="small"
                [filter]="true"
                filterBy="label"
                [showClear]="true"
                appendTo="body"
                panelStyleClass="ns-customer-panel"></p-select>

            <p-select
                [options]="insideRepOptions()"
                [(ngModel)]="insideRepValue"
                (ngModelChange)="applyFilters()"
                placeholder="Inside Rep"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"></p-select>

            <p-select
                [options]="nsStatusOptions()"
                [(ngModel)]="nsStatusValue"
                (ngModelChange)="applyFilters()"
                placeholder="NS Status"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"></p-select>

            <p-select
                [options]="quoteStatusOptions()"
                [(ngModel)]="quoteStatusValue"
                (ngModelChange)="applyFilters()"
                placeholder="Quote Status"
                optionLabel="label"
                optionValue="value"
                size="small"
                [showClear]="true"></p-select>

            @if (!viewport.isMobile()) {
                <div class="filter-actions">
                    <p-button
                        icon="pi pi-filter-slash"
                        severity="secondary"
                        size="small"
                        [outlined]="true"
                        (onClick)="clearFilters()"
                        pTooltip="Clear all filters"
                        tooltipPosition="bottom"></p-button>
                    <p-button
                        icon="pi pi-refresh"
                        size="small"
                        [loading]="isSyncing()"
                        (onClick)="refresh()"
                        pTooltip="Refresh NS statuses"
                        tooltipPosition="bottom"></p-button>
                    <p-button
                        icon="pi pi-download"
                        severity="secondary"
                        size="small"
                        [outlined]="true"
                        (onClick)="requestDownload()"
                        pTooltip="Download quote log"
                        tooltipPosition="bottom"></p-button>
                </div>
            }
        </div>
    }
</div>
